import { authHeader } from "../components/auth/Signin";
import { navigator } from "../components/Home/Home";

export function getBackendRoute(protocol, url = null) {
  switch (protocol) {
    case "WS":
      switch (window.location.protocol) {
        case "http:":
          return window.config.backend.ws_route
            .replace("127.0.0.1", window.location.hostname)
            .replace("http://", "ws://");
        case "https:":
        default:
          return window.config.backend.ws_route
            .replace("127.0.0.1", window.location.hostname)
            .replace("https://", "wss://");
      }
    case "HTTP":
    default:
      if (url && url.startsWith("/ow/dc/")) {
        return window.config.backend.http_route
          .replace("127.0.0.1", window.location.hostname)
          .replace("/ow/dc/", "");
      } else
        return window.config.backend.http_route.replace(
          "127.0.0.1",
          window.location.hostname
        );
  }
}

function Certificate_Back() {
  fetch(getBackendRoute("HTTP"), {
    method: "GET",
    headers: authHeader(),
  }).catch((error) => {
    console.log("Certificate Backend:", error);
    window.location.href = "/ow/view/certs/backend";
  });
}

export function authenticatedGetFetch(
  url,
  callback,
  redirect = null,
  signal = null,
  errCallback = null,
  isNotJson = false,
  fetchOptions = {}
) {
  if (!url.includes("http")) {
    url = getBackendRoute("HTTP", url) + url;
  }
  fetch(url, {
    signal: signal,
    method: "GET",
    headers: authHeader(),
    ...fetchOptions
  })
    .then((response) => {
      const statusCode = response.status;
      if (statusCode === 401) {
        // (Unauthorized)
        if (localStorage.getItem("token") != null) localStorage.clear();
        window.location.reload(false);

        if (redirect !== null) redirect.push("Signin");
      }
      let data;
      try {
        if (isNotJson) data = response.arrayBuffer();
        else data = response.json();
        return Promise.all([statusCode, data]);
      } catch (e) {
        return Promise.all([statusCode, {}]);
      }
    })
    .then((res) => {
      const data = res[1];
      if (res[0] < 400) {
        callback(data);
      } else {
        console.error("status [" + res[0] + "] in the result of " + url);
        if (errCallback instanceof Function) errCallback();
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error("error [", error, "] in the result of " + url);
        if (errCallback instanceof Function) errCallback();
      }
    });
}

export function authenticatedGetFetchWithoutLoginRedirection(
  url,
  callback,
  signal,
  errCallback
) {
  fetch(getBackendRoute("HTTP", url) + url, {
    signal: signal,
    method: "GET",
    headers: authHeader(),
  })
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then((res) => {
      const data = res[1];
      if (res[0] < 400)
        // OK
        callback(data);
      else {
        console.error("status [" + res[0] + "] in the result of " + url);
        if (errCallback instanceof Function) errCallback();
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error("error [", error, "] in the result of " + url);
        if (errCallback instanceof Function) errCallback();
      }
    });
}

export function authenticatedGetFetchBlob(url, callback, errCallback) {
  try {
    fetch(getBackendRoute("HTTP", url) + url, {
      method: "GET",
      headers: authHeader(),
    })
      .then((response) => {
        if (!response.ok) {
          if (errCallback instanceof Function) errCallback();
        } else return response.blob();
      })
      .then((blob) => {
        if (blob !== undefined) callback(URL.createObjectURL(blob));
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        else {
          console.error(error);
          if (errCallback instanceof Function) errCallback();
        }
      });
  } catch (error) {
    if (error.name === "AbortError") return;
    else {
      console.error(error);
      if (errCallback instanceof Function) errCallback();
    }
    //do nothing (bad token ? not a blob ?)
  }
}

// send a post and callback with the value of the status code (200 = OK, 401 = invalid token -> redirect to signin)
export function authenticatedPostFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authHeader().Authorization,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) {
        // (Unauthorized)
        if (res >= 400 && errorCallback instanceof Function) {
          errorCallback();
        } else if (callback instanceof Function) {
          callback(res);
        }
      } else {
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (errorCallback instanceof Function) errorCallback();
      }
    });
}

export function authenticatedPostFile(url, data, callback, errorCallback) {
  const formData = new FormData();
  formData.append("logo", data);
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "POST",
    headers: {
      /* 'Content-Type': "multipart/form-data", */
      Authorization: authHeader().Authorization,
    },
    body: formData,
  })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res.status !== 401)
        // (Unauthorized)
        callback(res);
      else {
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error("[" + url + "] error: ", error);
        if (errorCallback instanceof Function) errorCallback();
      }
    });
}

export function authenticatedPostFetchWithResult(
  url,
  body,
  callback,
  errorCallback,
  isNotJSON
) {
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authHeader().Authorization,
    },
    body: JSON.stringify(body),
  })
    .then(async (response) => {
      const statusCode = response.status;
      let data;
      if (isNotJSON === true) {
        switch (response.headers.get("content-type")) {
          case "application/json":
            try {
              data = await response.json();
            } catch (e) {
              data = {};
            }
            break;
          case "application/pdf":
            data = await response.blob();
            break;
          case "application/zip":
            data = await response.blob();
            break;
          default:
            data = await response.text();
        }
      } else {
        try {
          data = await response.json();
        } catch (e) {
          data = {};
        }
      }

      return Promise.all([statusCode, data]);
    })
    .then((response) => {
      if (response[0] === 401) {
        // (Unauthorized)
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      } else {
        if (response[0] >= 400 && errorCallback instanceof Function)
          errorCallback(response[1]);
        else callback(response[0], response[1]);
      }
    })
    .catch((error) => {
      if (error?.name === "AbortError") return;
      else {
        //Certificate_Back();
        console.error("[" + url + "] error: ", error);
        if (errorCallback instanceof Function) errorCallback();
      }
    });
}

export function authenticatedPutFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authHeader().Authorization,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) {
        // (Unauthorized)
        if (res >= 400 && errorCallback instanceof Function) {
          errorCallback();
        } else if (callback instanceof Function) {
          callback(res);
        }
      } else {
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
        if (errorCallback instanceof Function) errorCallback();
      }
    });
}

export function authenticatedDeleteFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authHeader().Authorization,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      const statusCode = response.status;
      return Promise.resolve(statusCode);
    })
    .then((res) => {
      if (res !== 401) {
        // (Unauthorized)
        if (res >= 400 && errorCallback instanceof Function) {
          errorCallback();
        } else if (callback instanceof Function) {
          callback(res);
        }
      } else {
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        console.error(error);
      }
    });
}

export function authenticatedPatchFetch(url, data, callback, errorCallback) {
  fetch(getBackendRoute("HTTP", url) + url, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: authHeader().Authorization,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
    })
    .then((res) => {
      if (res[0] === 401) {
        // (Unauthorized)
        localStorage.clear();
        navigator.push("Signin", { error: "session over" });
      } else {
        if (res[0] >= 400 && errorCallback instanceof Function)
          errorCallback(res[1]);
        else callback(res[0], res[1]);
      }
    })
    .catch((error) => {
      if (error.name === "AbortError") return;
      else {
        Certificate_Back();
        console.error("[" + url + "] error: ", error);
        if (errorCallback instanceof Function) errorCallback();
      }
    });
}
